interface HeaderProps {
  children?: React.ReactNode;
}

export function Header({ children }: HeaderProps) {
  if (!children) return null;

  return (
    <header className="border-b bg-background flex-shrink-0">
      <div className="flex items-center justify-between px-4 md:px-6 py-2.5 min-h-[44px] gap-2">
        {children}
      </div>
    </header>
  );
}
